// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._ENj2LgTWhAfgaZ5xNds{background-color:var(--background-primary-inverted-primary);border-radius:8px;box-shadow:0 0 0 1px rgba(18,21,23,.05),0 10px 30px -5px rgba(18,21,23,.1),0 20px 50px rgba(18,21,23,.05)}.StuPIi5RkQYEsKMPmPAk{outline:none;flex-direction:column;display:flex}.HW39l9a8zuYoRDDCu4DI{padding:4px;overflow-y:auto}.EsKwKL60Q2E5ksiw2SPL{padding:4px 4px 0}.P5OorDm0qAc9jSYCkSC0{display:none;position:absolute;top:0;left:100%}.p0H8NMU6YVU02XFPrz4t{border-top:1px solid var(--border-neutral-default);padding:4px}.Yxam158ibGoPFAA3wNWg{color:var(--gray-60);justify-content:center;padding:12px 0;font-size:12px;font-weight:400;line-height:16px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `_ENj2LgTWhAfgaZ5xNds`,
	"content": `StuPIi5RkQYEsKMPmPAk`,
	"items": `HW39l9a8zuYoRDDCu4DI`,
	"items--buttonActions": `EsKwKL60Q2E5ksiw2SPL`,
	"itemsButtonActions": `EsKwKL60Q2E5ksiw2SPL`,
	"items__sub": `P5OorDm0qAc9jSYCkSC0`,
	"itemsSub": `P5OorDm0qAc9jSYCkSC0`,
	"bottomActions": `p0H8NMU6YVU02XFPrz4t`,
	"noResult": `Yxam158ibGoPFAA3wNWg`
};
export default ___CSS_LOADER_EXPORT___;
